import checkIsEmpty from 'lodash/isEmpty';
import checkIsEqual from 'lodash/isEqual';

export const isEmpty = (arg: any) => {
    return checkIsEmpty(arg);
};

export const isEqual = (obj: any, obj2: any) => {
    return checkIsEqual(obj, obj2);
};

export function isEmptyValue(value: any) {
    if (!value) return true;
    if (value === null || value === undefined) return true;

    if (typeof value === 'string' && value.trim() === '') return true;

    if (typeof value === 'number' && isNaN(value)) return true;

    if (Array.isArray(value) && value.length === 0) return true;

    if (value instanceof Map || value instanceof Set) return value.size === 0;

    if (value instanceof WeakMap || value instanceof WeakSet) return false; // can't inspect size

    if (typeof value === 'object' && value.constructor === Object) {
        return Object.keys(value).length === 0;
    }

    return false;
}
